import { Box, Button, Stack, Typography } from "@mui/material";
import { useState } from "react";
import UploadFileIcon from '@mui/icons-material/UploadFile';

interface FileUploadDragAndDropProps {
    onChange: (file: File | null) => void;
    filetype: "PDF";
}

const FileUploadDragAndDrop = ({ onChange, filetype }: FileUploadDragAndDropProps) => {
    const [file, setFile] = useState<File | null>(null);
    const [filename, setFilename] = useState<string>("");
    const [dragOver, setDragOver] = useState(false);

    const mimeType = "application/pdf";

    const handleFileChange = (file: File) => {
        if (file.type === mimeType) {
            setFile(file);
            setFilename(file.name);
            onChange(file);
        } else {
            alert(`Por favor, selecione apenas arquivos ${filetype}.`);
        }
    };

    const handleDrag = (event: React.DragEvent<HTMLDivElement>) => {
        event.preventDefault();
        event.stopPropagation();
        setDragOver(event.type === "dragover");
    };

    const handleDrop = (event: React.DragEvent<HTMLDivElement>) => {
        event.preventDefault();
        setDragOver(false);
        const files = event.dataTransfer.files;
        if (files && files[0]) {
            handleFileChange(files[0]);
        }
    };

    const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.files && event.target.files[0]) {
            handleFileChange(event.target.files[0]);
        }
    };

    const formatFileSize = (bytes: number): string => {
        if (bytes === 0) return '0 Bytes';
        const k = 1024;
        const sizes = ['Bytes', 'KB', 'MB', 'GB'];
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
    };

    return (
        <Box
            sx={{
                border: dragOver ? "2px dashed #1976d2" : "2px dashed #ccc",
                borderRadius: 2,
                p: 2,
                textAlign: "center",
                cursor: "pointer",
                background: dragOver ? "#f0f7ff" : "inherit"
            }}
            onDragOver={handleDrag}
            onDragLeave={handleDrag}
            onDrop={handleDrop}
        >
            <Stack spacing={2} alignItems="center" direction={"row"}>
                <Stack spacing={2} alignItems="center" direction={"column"} width={"200px"}>
                    <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                        <label htmlFor="upload-drag-drop">
                            <Button 
                                variant="contained" 
                                component="span"
                                startIcon={<UploadFileIcon />}
                            >
                                {file || filename ? "Alterar" : "Selecionar"}
                            </Button>
                        </label>
                    </Box>
                    
                    <input
                        accept={mimeType}
                        style={{ display: "none" }}
                        id="upload-drag-drop"
                        type="file"
                        onChange={handleInputChange}
                    />
                    
                    <Typography variant="body2" sx={{ mt: 2 }}>
                        Arraste um arquivo {filetype} para esta área ou clique para selecionar.
                    </Typography>
                </Stack>

                {(file || filename) && (
                    <Box sx={{ 
                        display: "flex", 
                        flexDirection: "column",
                        alignItems: "center",
                        p: 2,
                        border: "1px solid #ccc",
                        borderRadius: 1,
                        backgroundColor: "#f9f9f9",
                        minWidth: "200px"
                    }}>
                        <Typography 
                            variant="body2" 
                            sx={{ 
                                fontWeight: "bold",
                                wordBreak: "break-word",
                                textAlign: "center",
                                mb: 1
                            }}
                        >
                            {filename || file?.name}
                        </Typography>
                        {file && (
                            <Typography 
                                variant="caption" 
                                sx={{ 
                                    color: "text.secondary",
                                    mb: 1
                                }}
                            >
                                {formatFileSize(file.size)}
                            </Typography>
                        )}
                    </Box>
                )}
            </Stack>
        </Box>
    );
};

export default FileUploadDragAndDrop;
